// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._nd5l1cy2{grid-area:title}._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._1bsb1osq{width:100%}\n._1lmcg5aa{grid-template-areas:\"title close\"}\n._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
